<template>
  <header class="sticky top-0 z-40 bg-black">
    <div class="flex items-center justify-between px-6 lg:px-16 xl:px-40 py-3.5">
      <RouterLink
        :to="{ name: 'home' }"
        class="flex shrink-0 items-center text-[#ededed] hover:text-primary transition-colors"
        aria-label="ZNIPP"
        @click="close"
      >
        <Logo class="h-[51px] w-auto" aria-hidden="true" />
      </RouterLink>

      <nav class="hidden lg:flex items-center gap-1 xl:gap-3">
        <RouterLink
          v-for="item in menuItems" :key="item.name"
          :to="{ name: item.name }"
          class="px-2 xl:px-3 py-1 text-[18px] font-medium text-white whitespace-nowrap transition-colors"
          :class="{ 'text-primary': isActive(item.name) }"
        >
          {{ t(item.textKey) }}
        </RouterLink>
      </nav>

      <div class="flex items-center gap-3">
        <RouterLink
          :to="{ name: 'contact' }"
          class="hidden lg:inline-flex items-center gap-4 rounded bg-primary hover:bg-primary-dark text-white hover:text-white text-[18px] px-4 py-2.5 transition-colors"
        >
          <span>{{ t('menu.contact') }}</span>
          <VaIcon name="call" :size="24" />
        </RouterLink>

        <button
          type="button"
          class="lg:hidden inline-flex items-center justify-center rounded p-2 text-white hover:bg-surface-1 transition-colors"
          :aria-expanded="open"
          aria-label="Toggle navigation"
          @click="open = !open"
        >
          <VaIcon :name="open ? 'close' : 'menu'" :size="28" />
        </button>
      </div>
    </div>

    <Transition
      enter-active-class="transition-[max-height,opacity] duration-300 ease-out"
      leave-active-class="transition-[max-height,opacity] duration-200 ease-in"
      enter-from-class="max-h-0 opacity-0"
      enter-to-class="max-h-[80vh] opacity-100"
      leave-from-class="max-h-[80vh] opacity-100"
      leave-to-class="max-h-0 opacity-0"
    >
      <div v-if="open" class="lg:hidden overflow-hidden bg-black border-t border-white/10">
        <nav class="flex flex-col px-6 py-4 gap-1">
          <RouterLink
            v-for="item in menuItems" :key="item.name"
            :to="{ name: item.name }"
            class="px-3 py-3 text-[18px] font-medium text-white transition-colors"
            :class="{ 'text-primary': isActive(item.name) }"
            @click="close"
          >
            {{ t(item.textKey) }}
          </RouterLink>
          <RouterLink
            :to="{ name: 'contact' }"
            class="mt-3 inline-flex items-center justify-center gap-4 rounded bg-primary hover:bg-primary-dark text-white hover:text-white text-[18px] px-4 py-3 transition-colors"
            @click="close"
          >
            <span>{{ t('menu.contact') }}</span>
            <VaIcon name="call" :size="24" />
          </RouterLink>
        </nav>
      </div>
    </Transition>
  </header>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { VaIcon } from 'vuestic-ui'
import Logo from '@/assets/images/logo.svg'

const { t } = useI18n()
const route = useRoute()
const open = ref(false)

const menuItems = [
  { name: 'services', textKey: 'menu.services' },
  { name: 'workbench', textKey: 'menu.workbench' },
  { name: 'approach', textKey: 'menu.approach' },
  { name: 'cases', textKey: 'menu.cases' },
  { name: 'blog', textKey: 'menu.blog' },
  { name: 'about', textKey: 'menu.about' },
]

const isActive = (name: string) => {
  if (route.name === name) return true
  if (name === 'cases' && route.name === 'caseDetail') return true
  if (name === 'blog' && route.name === 'blogDetail') return true
  return false
}

const close = () => { open.value = false }

watch(() => route.path, close)
</script>
